import type { LiquidityPoolsData } from "@stepfinance/liquidity";
import { useQuery } from "@tanstack/react-query";

import { useNetworkConfig } from "../../../contexts/app/config";
import { STEP_API_ENDPOINT } from "../../../utils/swr";

export const useLiquidityPoolsQuery = () => {
  const { network } = useNetworkConfig();

  return useQuery<LiquidityPoolsData>(
    ["liquidityPoolsData"],
    async () => {
      const res = await fetch(`${STEP_API_ENDPOINT}/v1/integration/liquidity?cluster=${network}`);
      if (!res.ok) {
        throw new Error("An error occurred while fetching liquidity pools.");
      }
      return res.json();
    },
    {
      staleTime: 30000,
    },
  );
};
